import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./RankingsPanelStyles";

export default class RankingsPanel extends Component {
  render() {
    const {
      cost_percentile,
      consumption_percentile,
      generation_percentile,
      cost_percentile_type,
      consumption_percentile_type,
      generation_percentile_type
    } = this.props;
    return (
      <Fragment>
        {cost_percentile && (
          <Fragment>
            <h3 className={css(styles.panelTitle)}>Energy Cost</h3>
            <div className={css(styles.panelWrapper)}>
              <h4
                className={css(styles.h4)}
              >{`${cost_percentile_type} ${cost_percentile.toFixed(0)}%`}</h4>
              <p className={css(styles.p)}>
                You spend more on energy than{" "}
                <span className={css(styles.highlight)}>{`${(
                  100 - cost_percentile
                ).toFixed(0)}%`}</span>{" "}
                of other users.
              </p>
            </div>
          </Fragment>
        )}
        {consumption_percentile && (
          <Fragment>
            <h3 className={css(styles.panelTitle)}>Consumption</h3>
            <div className={css(styles.panelWrapper)}>
              <h4
                className={css(styles.h4)}
              >{`${consumption_percentile_type} ${consumption_percentile.toFixed(
                0
              )}%`}</h4>
              <p className={css(styles.p)}>
                You use more energy than{" "}
                <span className={css(styles.highlight)}>{`${(
                  100 - consumption_percentile
                ).toFixed(0)}%`}</span>{" "}
                of other users.
              </p>
            </div>
          </Fragment>
        )}
        {generation_percentile && (
          <Fragment>
            <h3 className={css(styles.panelTitle)}>Generation</h3>
            <div className={css(styles.panelWrapper)}>
              <h4
                className={css(styles.h4)}
              >{`${generation_percentile_type} ${generation_percentile.toFixed(
                0
              )}%`}</h4>
              <p className={css(styles.p)}>
                You use more energy power than{" "}
                <span className={css(styles.highlight)}>{`${(
                  100 - generation_percentile
                ).toFixed(0)}%`}</span>{" "}
                of other users.
              </p>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}
